import { SEARCHLIGHT_ACTION_TYPE } from 'a/actions/searchlightActionCreators';
import { SEARCHLIGHT_EVENT_TYPE } from 'root/lib/SearchlightDispatcher';
import { GAME_MODE } from 'lib/constants';
import { ASSESSMENT_IDS } from 'a/hub/data/AssessmentIds';

const initialState = {
  shallTryAgain: {},
  numLevels: 0,
  isWriteResultInProgress: false,
};

const progressScreenReducer = (state = initialState, { type, payload = {} }) => {
  if (type === 'SELECT_ACTIVITY') {
    return initialState;
  }

  if (type === 'SET_NUM_LEVELS') {
    return { ...state, numLevels: payload.numLevels };
  }

  if (type === 'PUT_WRITE_RESULTS_REQUEST' && !ASSESSMENT_IDS.has(payload.GameId)) {
    return {
      ...state,
      isWriteResultInProgress: true,
    };
  }

  if (type === 'PUT_WRITE_RESULTS_RESPONSE' && !ASSESSMENT_IDS.has(payload.GameId)) {
    return {
      ...state,
      isWriteResultInProgress: false,
    };
  }

  if (type !== SEARCHLIGHT_ACTION_TYPE.SEARCHLIGHT_DISPATCH_EVENT) {
    return state;
  }

  const { eventType, details, gameId } = payload.application;
  switch (eventType) {
    case SEARCHLIGHT_EVENT_TYPE.ROUND_COMPLETE: {
      const { isEarlyExit } = details;
      const oldShallTryAgain = state.shallTryAgain[gameId] || false;
      return {
        ...state,
        shallTryAgain: {
          ...state.shallTryAgain,
          [gameId]: isEarlyExit || oldShallTryAgain,
        },
      };
    }

    case SEARCHLIGHT_EVENT_TYPE.LEVEL_COMPLETE: {
      const isAssignmentLink = details.gameMode === GAME_MODE.ASSIGNMENT_LINK;

      return {
        ...state,
        shallTryAgain: {
          ...state.shallTryAgain,
          [gameId]: isAssignmentLink ? false : !details.isSuccess,
        },
      };
    }

    default:
      return state;
  }
};

export default progressScreenReducer;
